// extracted by mini-css-extract-plugin
export var required = "_gd-0";